import type { TutorSessionRow } from '../../knowledgecenter/framework';

type Props = { sessions?: TutorSessionRow[] };

export function AITutorPanel({ sessions = [] }: Props) {
  return (
    <div className="space-y-3">
      {sessions.map((s) => (
        <div key={s.question} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs font-medium text-brand-600">{s.capability}</p>
          <p className="mt-1 text-sm font-medium">&quot;{s.question}&quot;</p>
          <p className="mt-2 text-xs text-slate-600 dark:text-slate-400">{s.answer}</p>
        </div>
      ))}
    </div>
  );
}
